import { GlobalConfigAspect } from './global-config.aspect';

export type { GlobalConfigMain } from './global-config.main.runtime';
export { GlobalConfigAspect };
export default GlobalConfigAspect;
